import axios from 'axios';

const subscribeToListing = async (dashboardId: string, listingId?: string) => {
  const config = {
    url: `/external/dash/${dashboardId}/almanac/subscriptions`,
    method: 'post' as const,
    data: {
      listingId,
    },
  };

  await axios.request<{ id: string }>(config);
};

export default subscribeToListing;
